export default "__VITE_ASSET__DbR4Z5Cm__"